import gql from "graphql-tag";

const CATEGORIES_QUERY = gql`
    query{
        blogCategories{
            id,
            category
            image{
                url
                formats
            }
        }
    }
`;

export default CATEGORIES_QUERY;